export default "__VITE_ASSET__DZDWIVur__"